<template>
  <div>
    <div
      style="
        display: flex;
        height: 90vh;
        overflow-y: scroll;
        border-top: 1px solid #f0f0f0;
      "
    >
      <div class="oneNav">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item
            v-for="(item, index) in storeFoodList"
            :key="index"
            :title="item.name"
            @click="oneNav(index)"
          />
        </van-sidebar>
      </div>
      <div class="twoNav">
        <div class="title">{{ title }}</div>
        <div class="items">
          <div class="item" v-for="(item, index) in twoClass" :key="index">
            <div class="foods">
              <img :src="Config.baseURL + item.picture" alt="" />
              <div class="info">
                <div>
                  <span>{{ item.name }}</span>
                  <div class="up_word">{{item.status == 1 ?'上架':'下架'}}</div>
                </div>
                <div>{{ "￥" + item.price }}</div>
              </div>
            </div>
            <!-- 排序 -->
            <input
              type="text"
              v-if="visible"
              v-model="item.rank"
              @blur="setSorts(item.id, item.rank)"
            />
            <!-- 上下架 -->
            <div v-show="showword" class="up_word"></div>
            <div v-if="showbox">
              <van-checkbox
                class="checkbox"
                ref="item_status"
                v-model="item.checked"
                @click="changeStatus(item.checked)"
              />
            </div>

            <!-- 批量改价 -->
            <div v-if="showPrice && item.is_spec" style="font-size: 0.4rem">
              <input
                type="number"
                v-model="item.price"
                @blur="upPrice('update', item.id, item.price)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="up_down" v-if="showbox">
        <div>
          <!-- <van-checkbox class="check_all" ref="all_status" v-model="checked" @click="checkedAll" />全选 -->
          <van-checkbox
            class="check_all"
            ref="all_status"
            v-model="checked"
            @click="checkedAll"
            >全选</van-checkbox
          >
        </div>
        <div @click="getCheckedArr(1)">上架</div>
        <div @click="getCheckedArr(0)">下架</div>
      </div>
      <div class="choose">
        <button type="info" class="shangjia" @click="upDown" :class="[this.showbox?'box1':'box2']">
          <img src="../../../assets/images/shangjia.png" alt="" />
          <div>上下架</div>
        </button>
        <button type="info" class="gaijia" @click="upPrice" :class="[this.showPrice?'box1':'box2']">
          <img src="../../../assets/images/gaijia.png" alt="" />
          <div>批量改价</div>
        </button>
        <button type="info" class="classpaixv" @click="jump">
          <img src="../../../assets/images/yidong.png" alt="" />
          <div>分类排序</div>
        </button>
        <button type="info" class="paixv" @click="upSort" :class="[this.visible?'box1':'box2']">
          <img src="../../../assets/images/yidong.png" alt="" />
          <div>菜品排序</div>
        </button>
        <van-button type="info" @click="submit">完成</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  data() {
    return {
      checked: false,
      oneClass: [], //一级分类数据
      activeKey: 0,
      twoClass: [], //二级分类数据
      storeFoodList: [],
      title: "",
      showbox: false, //批量上下架
      showword: false, //文字显示
      showPrice: false, //批量改价
      price: [], //需改价的数据
      num: 0,
      type: "sortFoodShelves",
      batch: "", //菜品ID
      status: "", //上下架状态
      visible: false,
      checkedIds: [],
      newfood: [],
    };
  },
  mounted() {
    this.getStoreFoodList();
  },
  methods: {
    // 上下架
    upDown() {
      this.showbox = !this.showbox;
      this.visible = false;
      this.showPrice = false;
      if (this.showbox == true) {
        var leftHeight1 = document.getElementsByClassName("oneNav")[0];
        leftHeight1.style.height = "94%";
        var rightHeight1 = document.getElementsByClassName("twoNav")[0];
        rightHeight1.style.height = "92.8%";
      } else {
        var leftHeight2 = document.getElementsByClassName("oneNav")[0];
        leftHeight2.style.height = "100%";
        var rightHeight2 = document.getElementsByClassName("twoNav")[0];
        rightHeight2.style.height = "100%";
      }
    },
    // 批量改价
    upPrice(type = "", id, price) {
      this.visible = false;
      this.showbox = false;
      var that = this;
      if (type == "update") {
        if (price <= 0) {
          Notify({ type: "danger", message: "价格不能小于等于0" });
          this.getStoreFoodList();
        } else {
          that.$http
            .post("/wechat/api.food_library/setSorts", {
              type: "sortFoodPrice",
              batch: [{ id: id, price: price }],
            })
            .then((response) => {
              if (response && response.body.code == 200) {
                this.getStoreFoodList();
              } else {
                Notify({ type: "danger", message: response.body.msg });
              }
            });
        }
      } else {
        that.showPrice = !that.showPrice;
      }
    },
    // 全选和反选
    checkedAll() {
      console.log(this.checked);
      console.log(this.$refs.all_status);
      this.$refs.all_status.toggle(this.checked);
      this.$refs.item_status.map((item) => {
        item.toggle(this.checked);
      });
    },
    // 是否选中
    changeStatus(status) {
      console.log(status);
      // 判断一下是不是取消选中了
      if (!status) {
        this.$refs.all_status.toggle(false);
      } else {
        var checked_num = 0;
        //  判断菜品是否全部都是选中状态
        this.storeFoodList.map((v) => {
          if (v.checked) {
            checked_num++;
          }
        });

        if (checked_num == this.storeFoodList.length) {
          this.$refs.all_status.toggle(true);
        } else {
          this.$refs.all_status.toggle(false);
        }
      }
    },
    // // 提取选中的菜品
    getCheckedArr(status) {
      let checkedIds = [];
      this.twoClass.map((v) => {
        if (v.checked) {
          checkedIds.push({ id: v.id });
        }
      });
      var params = {
        type: "sortFoodShelves",
        batch: checkedIds,
        status: status,
      };
      this.$http
        .post("/wechat/api.food_library/setSorts", params)
        .then((response) => {
          if (response && response.body.code == 200) {
            Notify({ type: "success", message: response.body.msg });
            // if (status == 1) {
            //   this.showbox = false;
            //   this.showword = true;
            //   document.getElementsByClassName("up_word")[0].innerHTML = "上架";
            //   document.getElementsByClassName("up_word")[0].style.color =
            //     "#1989fa";
            //   var rightHeight3 = document.getElementsByClassName("twoNav")[0];
            //   rightHeight3.style.height = "100%";
            // } else if (status == 0) {
            //   this.showbox = false;
            //   this.showword = true;
            //   document.getElementsByClassName("up_word")[0].innerHTML = "下架";
            //   document.getElementsByClassName("up_word")[0].style.color =
            //     "#c0dfff";
            // } else {
            //   document.getElementsByClassName("up_word").innerHTML = "";
            // }
            this.getStoreFoodList();
          } else {
            Notify({ type: "danger", message: response.body.msg });
          }
        });
    },
    // 获取菜品
    getStoreFoodList() {
      this.$http
        .post("/wechat/api.food_library/getStoreFoodList")
        .then((response) => {
          if (response && response.body.code == 200) {
            this.storeFoodList = response.body.data;
            this.twoClass = this.storeFoodList[this.activeKey].food;
            this.title = this.storeFoodList[this.activeKey].name;
            console.log("菜品", this.storeFoodList);
          }
        });
    },
    oneNav(index) {
      this.twoClass = this.storeFoodList[index].food;
      this.title = this.storeFoodList[index].name;
      this.twoClass.map((v) => {
        console.log("xxxxxxxxxxxxxxx", v);
        if (v.checked) {
          // checkedIds.push({ id: v.id });
          // console.log('hhhhhhhhhh',v.checked)
          this.checked = true;
        } else {
          this.checked = false;
        }
      });
      // console.log('qunaxian',this.checked)
    },
    upSort() {
      this.visible = !this.visible;
      this.showPrice = false;
      this.showbox = false;
    },
    setSorts(id, v) {
      // console.log("vvvvvvvvvvvvv", id, v);
      this.batch = [
        {
          id: id,
          sort: v,
        },
      ];
      this.$http
        .post("/wechat/api.food_library/setSorts", {
          type: "sortFood",
          batch: this.batch,
        })
        .then((response) => {
          if (response && response.body.code == 200) {
            // this.$toast.success(response.body.msg);
            this.getStoreFoodList();
          }
        });
    },
    jump() {
      this.$router.push("/ClassSort");
    },
    submit() {
    const hasInvalidPrice = this.storeFoodList.some(item =>
        item.food.some(i => i.price <= 0)
    );
		
		if(!hasInvalidPrice){
			this.$router.push("/FoodList");
		}else{
			Notify({ type: "danger", message: "菜品价格不能小于等于0" });
		}
      
    },
  },
};
</script>
<style scoped>
.van-sidebar::-webkit-scrollbar {
  display: none;
}

.oneNav {
  width: 26%;
  height: 100%;
  overflow: scroll;
}

.van-sidebar {
  width: 100% !important;
}
/* 右侧菜品 */
.twoNav {
  width: 74%;
  background-color: #ffffff;
  padding: 0 0.2rem;
  height: 100%;
  overflow: scroll;
}

.twoNav .title {
  font-size: 0.4rem;
}

.twoNav .items .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.twoNav .items .item input {
  width: 1rem;
  height: 0.5rem;
}

.twoNav .items .item .foods {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.3rem 0;
}

.twoNav {
  width: 74%;
  background-color: #ffffff;
  padding: 0 0.2rem;
  height: 100%;
  overflow: scroll;
}

.twoNav .title {
  font-size: 0.4rem;
}

.twoNav .items .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.twoNav .items .item input {
  width: 1rem;
  height: 0.5rem;
  font-size: 0.4rem;
  text-align: center;
}

.twoNav .items .item .foods {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.3rem 0;
}

.twoNav .items .item .foods img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.4rem;
}

.twoNav .items .item .foods .info {
  font-size: 0.4rem;
}
/* 上下架文字更改 */
.up_word {
    font-size: 0.26667rem;
    padding: 0.05333rem;
    display: inline-block;
    border: 0.02667rem solid red;
    border-radius: 0.05333rem;
    color: red;
    margin: 0 0.21333rem;
}
/* 上下架弹出框 */
.up_down {
  font-size: 16px;
  margin-top: -1.05rem;
  height: 1rem;
  line-height: 1rem;
  width: 100%;
}

.up_down div {
  float: left;
  border: 1px solid #c0dfff;
  width: 32.7%;
  text-align: center;
}

.up_down div:first-child {
  background-color: #c0dfff;
}
.up_down div:first-child .check_all {
  height: 1rem;
  width: 70%;
  margin-left: 0.8rem;
}

/* 底部内容 */
.foot {
  width: 100%;
  height: 10vh;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
}
/* 内容选择 */
.foot .choose {
  width: 94%;
  height: 1.5rem;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.4rem;
}

.classpaixv {
  background-color: #ffffff !important;
  color: #000000;
  padding: 0 !important;
  width: 1.4rem;
  border-radius: 0.2rem;
}
.box1{
	background-color: #f0f0f0 !important;
	color: #000000;
	padding: 0.1rem !important;
	width: 1.4rem;
	border-radius: 0.2rem;
}
.box2{
	background-color: #ffffff !important;
	color: #000000;
	padding: 0.1rem !important;
	width: 1.4rem;
	border-radius: 0.2rem;
}

.foot button {
  border: none;
}

.foot button img {
  width: 0.5rem;
  height: 0.5rem;
}

.twoNav .items .item .foods .info {
  font-size: 0.4rem;
}
.foot button > div {
  font-size: 0.3rem;
}
</style>
